import React from 'react';
import { PatientNewFlowInsuranceEditModalTemplate } from 'themes/application/facility-order-new-flow-insurance/components';
import { observer } from 'mobx-react';

@observer
class PatientNewFlowInsuranceEditModal extends React.Component {
    render() {
        return <PatientNewFlowInsuranceEditModalTemplate {...this.props} />
    }
}

export default PatientNewFlowInsuranceEditModal;
